// @ts-nocheck
import { useEffect, useRef } from 'react';

const resolve = explain => (typeof explain === 'function' ? explain() : explain);

export default function useCellCard(grid, card) {
  const lit = useRef([]);
  const pinned = useRef(null);
  const clearSources = () => {
    lit.current.forEach(el => el.classList.remove('gmSrcActual', 'gmSrcForecast', 'gmSrcSelf'));
    lit.current = [];
  };
  const light = (explainIn, el) => {
    clearSources();
    const explain = resolve(explainIn);
    if (!explain) return null;
    el.classList.add('gmSrcSelf');
    lit.current.push(el);
    if (grid.current) {
      const find = key => (key ? grid.current.querySelector('[data-cell="' + key + '"]') : null);
      (explain.highlights || []).forEach(h => {
        const target = find(h.key) || find(h.alt);
        if (!target || target === el) return;
        target.classList.add(h.tone === 'forecast' ? 'gmSrcForecast' : 'gmSrcActual');
        lit.current.push(target);
      });
    }
    return explain;
  };
  const hideCard = () => {
    pinned.current = null;
    clearSources();
    if (card.current) card.current.hide();
  };
  const hoverCell = (explain, el) => {
    if (!pinned.current) light(explain, el);
  };
  const leaveCell = () => {
    if (!pinned.current) clearSources();
  };
  const clickCell = (explain, el) => {
    if (pinned.current === el) return;
    const shown = light(explain, el);
    if (!shown) return;
    pinned.current = el;
    if (card.current) card.current.show(shown, el);
  };
  useEffect(() => {
    const onDown = e => { if (pinned.current && !(e.target.closest && e.target.closest('[data-explain]'))) hideCard(); };
    const onKey = e => { if (e.key === 'Escape' && pinned.current) hideCard(); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, []);
  return { hoverCell, leaveCell, clickCell, hideCard };
}
